export default __webpack_public_path__ + "static/media/btn_character_alignment_middle.39bd4a54.svg";